import devicesStyle from "../devices.module.css";

import { forwardRef, useState, useCallback, useImperativeHandle } from "react";
import { useSelector, useDispatch } from "react-redux";

// Package
import _ from "lodash";
import { useTranslation } from "react-i18next";

// Util
import { messageKeyPrefix } from "utils/message.util";

// Slice
import { deviceSettingActions } from "stores/slice/deviceSetting";

// UI components
import MessageBox from "components/MessageBox";
import Button from "components/Button";
import InlineTitle from "components/InlineTitle";
import LinkerWithA from "components/LinkerWithA";
import TooltipDialog from "components/TooltipDialog";
import InputWithIconButton from "components/InputWithIconButton";
import DropdownWithItem from "components/DropdownWithItem";
import Input from "components/Input";
import DropdownWithAdvancedSearch from "components/DropdownWithAdvancedSearch";

// Const
import Nuclias from "const/nuclias";
import {
  defaultDropdownStatusList,
  defaultDropdownProductCategoryList,
  defaultDropdownModelNameList,
  defaultDropdownUsedUnusedList,
  defaultMessages,
} from "../const";

const DevicesToolbarBox = forwardRef(
  (
    {
      changeMessages,
      changeOpenGenerateModalStatus,
      isOrgLevel,
      appendFilterData,
      appendPureFilterData,
      filterData,
      pageLimit,
      removeFilter,
      orgDeviceListFetch,
      orgListLimit,
      orgListFetch,
      seachOrgskip,
      setSeachOrgskip,
    },
    ref
  ) => {
    const { t } = useTranslation();
    const orgList = useSelector((state) => state.deviceSetting.orgList);
    const orgCount = useSelector((state) => state.deviceSetting.orgCount);
    const fetchedOrgCount = useSelector(
      (state) => state.deviceSetting.fetchedOrgCount
    );
    const dispatch = useDispatch();
    const defaultDropdownExpirationDateList = [
      { title: "b1c94ca2fb", value: "All", isActive: true },
      { title: t("b314cb794c", { day: 1 }), value: "1", isActive: false },
      { title: t("14a126cf45", { days: 7 }), value: "7", isActive: false },
      { title: t("14a126cf45", { days: 14 }), value: "14", isActive: false },
      { title: t("14a126cf45", { days: 30 }), value: "30", isActive: false },
      { title: t("14a126cf45", { days: 60 }), value: "60", isActive: false },
    ];
    const [messages, setMessages] = useState({ ...defaultMessages });
    const [selectedStatus, setSelectedStatus] = useState({
      ...defaultDropdownStatusList[0],
    });
    const [selectedProductCategory, setSelectedProductCategory] = useState({
      ...defaultDropdownProductCategoryList[0],
    });

    const [selectedModelName, setSelectedModelName] = useState({
      ...defaultDropdownModelNameList[0],
    });

    const [selectedUsedUnused, setSelectedUsedUnused] = useState({
      ...defaultDropdownUsedUnusedList[0],
    });

    const [selectedExpirationDate, setSelectedExpirationDate] = useState({
      ...defaultDropdownExpirationDateList[0],
    });

    const [dropdownStatusList, setDropdownStatusList] = useState(
      defaultDropdownStatusList
    );
    const [dropdownProductCategoryList, setDropdownProductCategoryList] =
      useState(defaultDropdownProductCategoryList);

    const [dropdownModelNameList, setDropdownModelNameList] = useState(
      defaultDropdownModelNameList
    );

    const [dropdownUsedUnusedList, setDropdownUsedUnusedList] = useState(
      defaultDropdownUsedUnusedList
    );

    const [dropdownExpirationDateList, setDropdownExpirationDateList] =
      useState(defaultDropdownExpirationDateList);

    const [inputMacAddress, setInputMacAddress] = useState("");

    const [inputDeviceUID, setInputDeviceUID] = useState("");

    const [inputSerialNumber, setInputSerialNumber] = useState("");

    // org search state
    // const [seachOrgskip, setSeachOrgskip] = useState(0);
    const [searchOrgkey, setSearchOrgkey] = useState("");

    useImperativeHandle(ref, () => ({
      setChildDeviceType(state) {
        setSelectedProductCategory(state);
        const clonedDefaultDropdownStatusList = _.cloneDeep(
          defaultDropdownStatusList
        );
        setSelectedStatus({ ...clonedDefaultDropdownStatusList[0] });
        setDropdownStatusList(clonedDefaultDropdownStatusList);
        changeListAction(
          state,
          defaultDropdownProductCategoryList,
          "ProductCategory"
        );
      },
    }));

    const setDropdownList = (data, type) => {
      switch (type) {
        case "StatusList":
          setDropdownStatusList(data);
          break;
        case "ProductCategory":
          setDropdownProductCategoryList(data);
          break;
        case "ModelName":
          setDropdownModelNameList(data);
          break;
        case "UsedUnused":
          setDropdownUsedUnusedList(data);
          break;
        case "ExpirationDate":
          setDropdownExpirationDateList(data);
          break;
        default:
      }
    };

    const changeListAction = (selectedItem, defaultDropdownList, type) => {
      const clonedDefaultDropdownList = _.cloneDeep(defaultDropdownList);
      for (let item of clonedDefaultDropdownList) {
        item.isActive =
          item.value.toLowerCase() === selectedItem.value.toLowerCase()
            ? true
            : false;
      }
      setDropdownList(clonedDefaultDropdownList, type);
    };

    const searchStringTransfer = (key, value) => {
      let transferKey = "";
      let transferValue = "";

      switch (key) {
        case "onlineStatus":
          transferKey = t("ec53a8c4f0");
          const statusValue = value.charAt(0).toUpperCase() + value.slice(1);
          transferValue =
            statusValue === "Online"
              ? t("54f664c70c")
              : statusValue === "Offline"
              ? t("8d9da4bc0e")
              : statusValue === "Dormant"
              ? t("96542608b4")
              : "";
          break;
        case "orgName":
          transferKey = t("d6b258792f");
          transferValue = value;
          break;
        case "productCategory":
          transferKey = t("cecd547f56");
          transferValue =
            value.toLowerCase() === "ap"
              ? t("cb3f9a1103")
              : value.toLowerCase() === "switch"
              ? t("bbc155fb2b")
              : value.toLowerCase() === "gateway"
              ? t("926dec9494")
              : "";
          break;
        case "modelName":
          transferKey = t("f6b4b7df89");
          transferValue = value.toUpperCase();
          break;
        case "used":
          transferKey = t("c29fb273b8") + "/" + t("8a73657240");
          transferValue =
            value.toLowerCase() === "used" ? t("c29fb273b8") : t("8a73657240");
          break;
        case "expirationTimeStamp":
          transferKey = t("53f289dc8e");
          transferValue = t("b314cb794c", { day: value });
          break;
        case "macAddress":
          transferKey = t("2e25c28535");
          transferValue = value;
          break;
        case "uid":
          transferKey = t("e7d22294bd");
          transferValue = value;
          break;
        case "serialNumber":
          transferKey = t("e86922432f");
          transferValue = value;
          break;
        default:
      }
      return [transferKey, transferValue];
    };

    const formatSearchString = (filterData) => {
      const order = {
        onlineStatus: 1,
        orgName: 2,
        productCategory: 3,
        modelName: 4,
        used: 5,
        expirationTimeStamp: 6,
        macAddress: 7,
        uid: 8,
        serialNumber: 9,
      };
      let searchString = "";
      let operator = "";
      if (_.isEmpty(filterData)) return "";
      const sorted = Object.keys(filterData).sort((key1, key2) => {
        return order[key1] - order[key2];
      });
      for (const key of sorted) {
        if (Nuclias.searchItemUseSelect.includes(key)) {
          if (
            filterData[key].toLowerCase() === "all" ||
            filterData[key].toLowerCase() === "both" ||
            filterData[key].toLowerCase() === ""
          ) {
            continue;
          }
        } else {
          if (filterData[key].toLowerCase() === "") {
            continue;
          }
        }
        operator = searchString !== "" ? " AND " : "";
        const [transferKey, transferValue] = searchStringTransfer(
          key,
          filterData[key]
        );
        searchString =
          searchString + operator + `(${transferKey}:${transferValue})`;
      }
      return searchString;
    };

    return (
      <>
        <MessageBox
          show={!!messages.danger}
          label={t(`${messageKeyPrefix.e.s}${messages.danger}`)}
          variant="danger"
          onClose={() => setMessages({ ...messages, danger: null })}
        />
        <MessageBox
          show={!!messages.success}
          label={t(messages.success)}
          variant="success"
          onClose={() => setMessages({ ...defaultMessages, success: null })}
        />
        <MessageBox
          show={!!messages.error}
          label={t(`${messageKeyPrefix.e.s}${messages.error}`)}
          variant="danger"
          onClose={() => setMessages({ ...defaultMessages, error: null })}
        />
        <MessageBox
          show={!!messages.warning}
          label={t(messages.warning)}
          variant="warning"
          onClose={() => setMessages({ ...defaultMessages, warning: null })}
        />
        <InlineTitle isNonUnderline>
          <DropdownWithAdvancedSearch
            value={formatSearchString(filterData)}
            dataBsToggleOnInput={true}
            dataBsToggleOnButton={true}
            readOnly
            alignEnd={true}
            dropdownMenuStyle={{ minWidth: 371 }}
          >
            <li className="mt-2">
              <div className="form-title">{t("ec53a8c4f0")} :</div>
              <DropdownWithItem
                id="status-dropdown"
                type="normal"
                selectedItem={selectedStatus}
                itemList={dropdownStatusList}
                onClick={(item) => {
                  setSelectedStatus(item);
                  appendFilterData({ onlineStatus: item.value });
                  changeListAction(
                    item,
                    defaultDropdownStatusList,
                    "StatusList"
                  );
                }}
              />
            </li>
            {!isOrgLevel && (
              <li className="mt-2">
                <div className="form-title">{t("d6b258792f")} :</div>
                <div className={devicesStyle["advanced-select-org-container"]}>
                  <DropdownWithAdvancedSearch
                    value={searchOrgkey}
                    buttonIcon={"enter"}
                    dataBsToggleOnInput={true}
                    dataBsToggleOnButton={true}
                    subContainerOnClick={(e) => e.stopPropagation()}
                    onChange={(e) => {
                      setSearchOrgkey(e.target.value);
                    }}
                    onClick={(e) => {
                      if (e.target.value.trim() === "") {
                        setSeachOrgskip(0);
                        setSearchOrgkey("");
                        dispatch(deviceSettingActions.cleanOrg());
                        orgListFetch(encodeURI("%"), 0);
                      } else {
                        setSeachOrgskip(0);
                        setSearchOrgkey("");
                        dispatch(deviceSettingActions.cleanOrg());
                        appendPureFilterData({ orgName: "" });
                        const removedFilterData = removeFilter(
                          _.cloneDeep({ ...filterData, orgName: "" })
                        );
                        //orgDeviceListFetch（pageLimit,skip,sort,reverse,isOrgLevel,filter,orgName,orgNameSkip）
                        orgDeviceListFetch(
                          pageLimit,
                          0,
                          "",
                          1,
                          isOrgLevel,
                          removedFilterData,
                          encodeURI("%"),
                          0
                        );
                      }
                    }}
                    buttonOnClick={() => {
                      setSeachOrgskip(0);
                      setSearchOrgkey("");
                      dispatch(deviceSettingActions.cleanOrg());
                      orgListFetch(encodeURI("%"), 0);
                    }}
                    onKeyDown={(e) => {
                      if (e.target.value.trim() !== "" && e.key === "Enter") {
                        setSeachOrgskip(0);
                        dispatch(deviceSettingActions.cleanOrg());
                        orgListFetch(e.target.value, 0);
                      }
                    }}
                  >
                    <div className={devicesStyle["more-org"]}>
                      <div className={devicesStyle["show-more-info"]}>
                        {t("3a6d32cc65", { count: fetchedOrgCount })} {orgCount}{" "}
                        {t("cfb453439b")}.
                      </div>
                      <LinkerWithA
                        label={
                          orgCount > seachOrgskip + orgListLimit
                            ? t("2a725a2a3d")
                            : ""
                        }
                        href="#"
                        className="linker-blue show-more text-decoration-underline"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setSeachOrgskip(seachOrgskip + orgListLimit);
                          orgListFetch(
                            searchOrgkey === "" ? encodeURI("%") : searchOrgkey,
                            seachOrgskip + orgListLimit
                          );
                        }}
                      ></LinkerWithA>
                    </div>
                    {orgList &&
                      orgList.map((org, index) => {
                        return (
                          <li
                            key={index}
                            className="search-org-item"
                            value={org.name}
                            onClick={(e) => {
                              setSearchOrgkey(e.target.innerText);
                              appendFilterData({
                                orgName: e.target.innerText,
                              });
                            }}
                          >
                            {org.name}
                          </li>
                        );
                      })}
                  </DropdownWithAdvancedSearch>
                </div>
              </li>
            )}
            <li className="mt-2">
              <div className="form-title">{t("cecd547f56")} :</div>
              <DropdownWithItem
                id="product-category-dropdown"
                type="normal"
                selectedItem={selectedProductCategory}
                itemList={dropdownProductCategoryList}
                onClick={(item) => {
                  setSelectedProductCategory(item);
                  appendFilterData({
                    productCategory: item.value,
                  });
                  changeListAction(
                    item,
                    defaultDropdownProductCategoryList,
                    "ProductCategory"
                  );
                }}
              />
            </li>
            <li className="mt-2">
              <div className="form-title">{t("f6b4b7df89")} :</div>
              <DropdownWithItem
                id="model-name-dropdown"
                type="normal"
                selectedItem={selectedModelName}
                itemList={dropdownModelNameList}
                onClick={(item) => {
                  setSelectedModelName(item);
                  appendFilterData({ modelName: item.value });
                  changeListAction(
                    item,
                    defaultDropdownModelNameList,
                    "ModelName"
                  );
                }}
              />
            </li>
            <li className="mt-2">
              <div className="form-title">
                {t("c29fb273b8")}/{t("8a73657240")}
              </div>
              <DropdownWithItem
                id="used-unused-dropdown"
                type="normal"
                selectedItem={selectedUsedUnused}
                itemList={dropdownUsedUnusedList}
                onClick={(item) => {
                  setSelectedUsedUnused(item);
                  appendFilterData({ used: item.value });
                  changeListAction(
                    item,
                    defaultDropdownUsedUnusedList,
                    "UsedUnused"
                  );
                }}
              />
            </li>
            <li className="mt-2">
              <div className="form-title">{t("53f289dc8e")} :</div>
              <DropdownWithItem
                id="expiration-dropdown"
                type="normal"
                selectedItem={selectedExpirationDate}
                itemList={dropdownExpirationDateList}
                onClick={(item) => {
                  setSelectedExpirationDate(item);
                  appendFilterData({ expirationTimeStamp: item.value });
                  changeListAction(
                    item,
                    defaultDropdownExpirationDateList,
                    "ExpirationDate"
                  );
                }}
              />
            </li>

            {isOrgLevel && (
              <>
                <li className="mt-2">
                  <div className="form-title">{t("2e25c28535")} :</div>
                  <Input
                    type="txt"
                    placeholder="e.g. 3C:1E:04:16:53:20"
                    autoComplete="mac-filter"
                    value={inputMacAddress}
                    onChange={(e) => {
                      setInputMacAddress(e.target.value);
                      appendFilterData({
                        macAddress: e.target.value.toLowerCase().trim(),
                      });
                    }}
                    onClick={() => {
                      setInputMacAddress("");
                      appendFilterData({
                        macAddress: "",
                      });
                    }}
                  />
                </li>
                <li className="mt-2">
                  <div className="form-title">{t("e7d22294bd")} :</div>
                  <Input
                    type="txt"
                    placeholder="e.g. AABBCCDDEEFF"
                    autoComplete="deviceUID-filter"
                    value={inputDeviceUID}
                    onChange={(e) => {
                      setInputDeviceUID(e.target.value);
                      appendFilterData({
                        uid: e.target.value.toLowerCase().trim(),
                      });
                    }}
                    onClick={() => {
                      setInputDeviceUID("");
                      appendFilterData({
                        uid: "",
                      });
                    }}
                  />
                </li>
                <li className="mt-2">
                  <div className="form-title w-100">{t("e86922432f")} :</div>
                  <Input
                    type="txt"
                    placeholder="e.g. AA1B1CC000001"
                    autoComplete="serialNumber-filter"
                    value={inputSerialNumber}
                    onChange={(e) => {
                      setInputSerialNumber(e.target.value);
                      appendFilterData({
                        serialNumber: e.target.value.toLowerCase().trim(),
                      });
                    }}
                    onClick={() => {
                      setInputSerialNumber("");
                      appendFilterData({
                        serialNumber: "",
                      });
                    }}
                  />
                </li>
              </>
            )}

            {!isOrgLevel && (
              <>
                <li className="mt-2">
                  <div className="form-title">{t("2e25c28535")} :</div>
                  <InputWithIconButton
                    type="search"
                    placeholder={t("13348442cc")}
                    autoComplete="msp-search"
                    value={inputMacAddress}
                    buttonClassName="icon-search-enter"
                    onChange={(e) => {
                      setInputMacAddress(e.target.value.trim());
                    }}
                    onClick={(e) => {
                      if (e.target.value.trim().length !== 0) {
                        setInputMacAddress("");
                        appendFilterData({
                          macAddress: "",
                        });
                      }
                    }}
                    buttonOnClick={(e) => {
                      e.stopPropagation();
                      appendFilterData({
                        macAddress: inputMacAddress.toLowerCase(),
                      });
                    }}
                  />
                </li>
                <li className="mt-2">
                  <div className="form-title">{t("e7d22294bd")} :</div>
                  <InputWithIconButton
                    type="search"
                    placeholder={t("13348442cc")}
                    autoComplete="msp-search"
                    value={inputDeviceUID}
                    buttonClassName="icon-search-enter"
                    onChange={(e) => {
                      setInputDeviceUID(e.target.value.trim());
                    }}
                    onClick={(e) => {
                      if (e.target.value.trim().length !== 0) {
                        setInputDeviceUID("");
                        appendFilterData({
                          uid: "",
                        });
                      }
                    }}
                    buttonOnClick={(e) => {
                      e.stopPropagation();
                      appendFilterData({ uid: inputDeviceUID.toLowerCase() });
                    }}
                  />
                </li>
                <li className="mt-2">
                  <div className="form-title w-100">{t("e86922432f")} :</div>
                  <InputWithIconButton
                    type="search"
                    placeholder={t("13348442cc")}
                    autoComplete="msp-search"
                    value={inputSerialNumber}
                    buttonClassName="icon-search-enter"
                    onChange={(e) => {
                      setInputSerialNumber(e.target.value.trim());
                    }}
                    onClick={(e) => {
                      if (e.target.value.trim().length !== 0) {
                        setInputSerialNumber("");
                        appendFilterData({
                          serialNumber: "",
                        });
                      }
                    }}
                    buttonOnClick={(e) => {
                      e.stopPropagation();
                      appendFilterData({
                        serialNumber: inputSerialNumber.toLowerCase(),
                      });
                    }}
                  />
                </li>
              </>
            )}
          </DropdownWithAdvancedSearch>

          {!isOrgLevel && (
            <Button
              label="Generate"
              className="btn-grey"
              onClick={() => changeOpenGenerateModalStatus(true)}
            />
          )}

          {!isOrgLevel && (
            <Button
              label="Download"
              className="btn-grey"
              onClick={() => {
                console.log("Click on download");
                changeMessages({
                  error:
                    "Please click generate to prepare the list to download.",
                });
              }}
            />
          )}

          {!isOrgLevel && (
            <TooltipDialog
              placement="left"
              title="Click Generate to prepare the file to download. It may take few minutes to generate the file. You will receive an email from the Nuclias Cloud team once the file is ready to download."
            ></TooltipDialog>
          )}
          {isOrgLevel && (
            <Button
              label=""
              title="Download as CSV"
              className="icon-download"
              style={{ border: "none", height: 25, backgroundColor: "#fff" }}
              onClick={() => console.log("Download as CSV")}
            />
          )}
        </InlineTitle>
      </>
    );
  }
);

export default DevicesToolbarBox;
